import useThemeContext from '~/client/hooks/theme/useThemeContext';
import useSite from '~/client/hooks/useSite';
import getSiteLogo from '~/shared/cdn/getSiteLogo';
import Img from '../../images/Img';
import BreadcrumbItem from '../BreadcrumbItem';

type Props = { showLogo?: boolean; size?: 'large' | 'default' };

const BaseCrumb: FC<Props> = ({ showLogo, size }) => {
  const { colorScheme } = useThemeContext();
  const { site, siteConfig } = useSite();

  if (!showLogo) {
    return (
      <BreadcrumbItem size={size} breadcrumb={{ to: '/' }}>
        {siteConfig.name}
      </BreadcrumbItem>
    );
  }

  return (
    <BreadcrumbItem breadcrumb={{ to: '/' }}>
      <Img
        src={getSiteLogo(site, colorScheme)}
        height={size === 'large' ? 48 : 32}
      />
    </BreadcrumbItem>
  );
};

export default BaseCrumb;
